export const LOGO_URL =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_62c3f953-040c-422f-a1ef-26f822aeb9e8/artifacts/bb3744b8ec669a67_IMG_0068.jpeg.webp";

export const IMAGES = {
  blueDoor:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_62c3f953-040c-422f-a1ef-26f822aeb9e8/artifacts/fdbfa9d12fc3699a_mcc.webp",
  bathConcrete:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_62c3f953-040c-422f-a1ef-26f822aeb9e8/artifacts/c80b81f7da249970_mcc%202.webp",
  kitchenFarmhouse:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_62c3f953-040c-422f-a1ef-26f822aeb9e8/artifacts/d788d48ba7b01cd6_mcc%203.webp",
  kitchenCoastal:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_mcmullen-build/artifacts/4241c748141f9744_mcc%206.webp",
  bathMarble:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_mcmullen-build/artifacts/f15bf8cd8c3cfd08_mcc%207.webp",
  buildBlock:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_mcmullen-build/artifacts/7bed2529ba5f77dd_mcc%208.webp",
  sunroom:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_mcmullen-build/artifacts/00e7f4ce537f45d0_mcc%209.webp",
  kitchenGeometric:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_mcmullen-build/artifacts/dda1fe36070bf0c8_mcc%2010.webp",
  kitchenBarnDoor:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_mcmullen-build/artifacts/b2bfa58fa9fc232d_mcc%204.webp",
  bathMosaic:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_mcmullen-build/artifacts/7f442df7fc5ccd3a_mcc%205.webp",
  kitchenDisplay:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_mcmullen-build/artifacts/3f5093c83a39603f_pexels-curtis-adams-1694007-8186517.webp",
  wetBar:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_mcmullen-build/artifacts/2b3a3d99ec88d413_pexels-curtis-adams-1694007-8032006.webp",
  kitchenShaker:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_mcmullen-build/artifacts/efed7b259075cc62_pexels-curtis-adams-1694007-16501326.webp",
  commercialTower:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_mcmullen-build/artifacts/f4d2febfc79c1615_pexels-adrien-olichon-1257089-5230087.webp",
  commercialOffice:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_mcmullen-build/artifacts/776a14e8314d5fcc_pexels-artbovich-7534210.webp",
  commercialClinic:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_mcmullen-build/artifacts/59d3e6d7fe522680_pexels-babydov-7789601.webp",
};

export const PHONE = "321-313-0996";
export const PHONE_HREF = "tel:+13213130996";
export const EMAIL = "info@mcmullenconstructioncompanyllc.com";
export const LICENSE = "CGC License #1533095";

export const SERVICES = [
  {
    id: "remodel",
    title: "Residential Remodel",
    blurb: "Apartments, homes and vacation properties transformed with obsessive attention to detail.",
    image: IMAGES.sunroom,
    points: ["Whole-home renovations", "Vacation property refreshes", "Kitchen & bath transformations"],
  },
  {
    id: "custom-build",
    title: "Custom Home Building & Additions",
    blurb: "Creative and inviting family environments, built from the foundation up.",
    image: IMAGES.buildBlock,
    points: ["Ground-up custom homes", "Seamless structural additions", "Concrete block & frame construction"],
  },
  {
    id: "roofing",
    title: "Residential Roofing",
    blurb: "Metal, tile, and shingle roof replacements and repairs - delivered by a State certified general contractor committed to the highest industry standards.",
    image: IMAGES.blueDoor,
    points: ["Standing-seam metal roofs", "Tile & shingle replacement", "Storm-ready repairs"],
  },
  {
    id: "design",
    title: "Design & Engineering Services",
    blurb: "In-house design and engineering that carries your project from first sketch to final inspection.",
    image: IMAGES.bathMarble,
    points: ["Concept & space planning", "Permit-ready drawings", "Engineering coordination"],
  },
  {
    id: "commercial-contracting",
    title: "Commercial Contracting",
    blurb: "Full-scope general contracting for offices, retail and multi-story commercial properties - delivered on schedule, to code.",
    image: IMAGES.commercialTower,
    points: ["Office & retail build-outs", "Multi-story commercial projects", "Code-compliant delivery"],
  },
  {
    id: "commercial-design-build",
    title: "Commercial New Design & Build",
    blurb: "From blank site to finished workspace - design, engineering and construction under one roof.",
    image: IMAGES.commercialOffice,
    points: ["Ground-up commercial builds", "Integrated design-build delivery", "Modern workspace construction"],
  },
  {
    id: "commercial-remodeling",
    title: "Commercial Remodeling",
    blurb: "Clinical, office and retail spaces remodeled around your operations - precise, clean and disruption-aware.",
    image: IMAGES.commercialClinic,
    points: ["Medical & clinical fit-outs", "Office modernizations", "Retail space renovations"],
  },
];

export const GALLERY = [
  { src: IMAGES.blueDoor, category: "Exteriors", title: "Blue Door Estate Entry", desc: "Stacked stone, standing-seam metal roof and bold blue entry doors." },
  { src: IMAGES.sunroom, category: "Exteriors", title: "Glass Sunroom & Landscape", desc: "Indoor-outdoor living with full-height glass and sculpted gardens." },
  { src: IMAGES.buildBlock, category: "New Construction", title: "Ground-Up Custom Build", desc: "Concrete block construction with a standing-seam metal roof." },
  { src: IMAGES.bathConcrete, category: "Bathrooms", title: "Concrete Spa Retreat", desc: "Large-format concrete-look tile with matte black fixtures." },
  { src: IMAGES.bathMarble, category: "Bathrooms", title: "Marble Master Spa", desc: "Multi-head shower system and a freestanding soaking tub." },
  { src: IMAGES.kitchenFarmhouse, category: "Kitchens", title: "Farmhouse Granite Kitchen", desc: "Custom cream cabinetry, granite island and a barn-door pantry." },
  { src: IMAGES.kitchenCoastal, category: "Kitchens", title: "Coastal Teal Kitchen", desc: "Crisp white cabinetry with a teal herringbone backsplash." },
  { src: IMAGES.kitchenGeometric, category: "Kitchens", title: "Geometric Chef's Kitchen", desc: "Marble waterfall island and a statement geometric backsplash." },
  { src: IMAGES.kitchenBarnDoor, category: "Kitchens", title: "Barn Door Gathering Kitchen", desc: "Granite island, stainless suite and sliding barn doors in an open-concept plan." },
  { src: IMAGES.kitchenDisplay, category: "Kitchens", title: "Glass-Front Display Kitchen", desc: "Custom white cabinetry with glass-front china displays and crown moulding." },
  { src: IMAGES.wetBar, category: "Kitchens", title: "Entertainer's Wet Bar", desc: "Built-in wine cooler, wine racks and subway tile - made for hosting." },
  { src: IMAGES.kitchenShaker, category: "Kitchens", title: "Classic Shaker Kitchen", desc: "White shaker cabinetry, dark stone counters and a full stainless suite." },
  { src: IMAGES.bathMosaic, category: "Bathrooms", title: "Mosaic Floor Walk-In Shower", desc: "Frameless glass shower, subway tile and a double vanity in matte grey." },
  { src: IMAGES.commercialTower, category: "Commercial", title: "Glass Commercial Tower", desc: "Full-height reflective glass facade on a multi-story commercial build." },
  { src: IMAGES.commercialOffice, category: "Commercial", title: "Modern Office Build-Out", desc: "Open workspace with glass partitions, exposed services and custom joinery." },
  { src: IMAGES.commercialClinic, category: "Commercial", title: "Clinical Fit-Out", desc: "Treatment room remodeled to clinical standards with custom cabinetry." },
];

export const GALLERY_CATEGORIES = ["All", "Exteriors", "Kitchens", "Bathrooms", "New Construction", "Commercial"];

export const MARQUEE_ITEMS = [
  "Residential Remodel",
  "Custom Home Building",
  "Roofing",
  "Design & Engineering",
  "Licensed CGC #1533095",
  "Remodel & New Construction",
];

export const STATEMENT = {
  title: "Website Accessibility Statement",
  updated: "Last Updated: February 27, 2026",
  sections: [
    {
      heading: "Our Commitment to Accessibility",
      body: "We are committed to ensuring digital accessibility for people with disabilities. We are continually improving the user experience for everyone and applying relevant accessibility standards to enhance usability and inclusivity. Our goal is to provide a website that is accessible to the widest possible audience, regardless of technology or ability.",
    },
    {
      heading: "Accessibility Standards",
      body: "We strive to conform to the Web Content Accessibility Guidelines (WCAG) 2.1 Level AA, which are widely recognized as the industry standard for website accessibility. Accessibility is an ongoing process, and we are actively working toward improving the accessibility and usability of our website.",
    },
    {
      heading: "Accessibility Technology & Tools",
      body: "To support our accessibility efforts, we have deployed industry-standard accessibility technology designed to enhance usability and assist visitors with disabilities. These tools may provide features such as:",
      list: [
        "Screen reader enhancements",
        "Keyboard navigation improvements",
        "Color contrast adjustments",
        "Text size and spacing controls",
        "Focus indicators",
        "Additional accessibility interface options",
      ],
      after: "This technology helps us improve accessibility while we continue broader auditing, remediation, and development efforts.",
    },
    {
      heading: "Ongoing Improvement",
      body: "Accessibility is an ongoing initiative. We are:",
      list: [
        "Reviewing site content and functionality regularly",
        "Working with developers and accessibility tools",
        "Identifying and remediating barriers",
        "Incorporating accessibility into future design and development",
      ],
      after: "We understand accessibility is a continuous journey and are committed to making improvements over time.",
    },
    {
      heading: "Third-Party Content",
      body: "Some areas of the website may include third-party content, plugins, or integrations that are not fully controlled by us. While we encourage vendors to provide accessible content, we cannot guarantee accessibility of third-party features. However, we welcome feedback regarding any issues encountered.",
    },
    {
      heading: "Feedback & Assistance",
      body: "If you experience difficulty accessing any part of this website, need assistance, or would like to request content in an alternative format, please contact us.",
      list: ["The page URL", "Description of the issue", "Your preferred contact method"],
      after: "Contact: Information on our Contact Us Page. We aim to respond within a reasonable timeframe and will make reasonable efforts to provide accessible alternatives.",
    },
    {
      heading: "Good Faith Efforts",
      body: "We are making good-faith efforts to comply with accessibility standards and improve usability for individuals with disabilities. Despite our efforts, some content may not yet fully meet the strictest accessibility standards due to the evolving nature of technology and ongoing updates. We appreciate your understanding as we continue improving accessibility.",
    },
    {
      heading: "Terms & Conditions - Accessibility Clause",
      body: "We are committed to providing an accessible website experience for all users and strive to follow recognized accessibility standards, including WCAG guidelines. We have implemented industry-standard accessibility tools and continue to review, update, and improve our website to enhance accessibility. Because accessibility is an ongoing process, some areas of the website may not yet fully conform to all accessibility standards. If you encounter accessibility barriers, please contact us so we can provide assistance, offer alternative access, and address the issue where feasible. Nothing in these Terms is intended to limit any rights available under applicable accessibility laws.",
    },
  ],
};
